export default {
  more: 'Voir plus',
  retract: 'Voir moins',
}
